var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news" }, [
    _c("link", {
      attrs: {
        rel: "stylesheet",
        href: "https://pro.fontawesome.com/releases/v5.14.0/css/all.css",
        integrity:
          "sha384-VhBcF/php0Z/P5ZxlxaEx1GwqTQVIBu4G4giRWxTKOCjTxsPFETUDdVL5B6vYvOt",
        crossorigin: "anonymous",
      },
    }),
    _c("div", { staticClass: "kroppensContainer" }, [
      _c("div", { staticClass: "newsContainer" }, [
        _c(
          "div",
          { staticClass: "articles" },
          [
            this.$root.admin
              ? _c(
                  "p",
                  { staticClass: "heading" },
                  [
                    this.$root.admin
                      ? _c("font-awesome-icon", {
                          class: ["settings", _vm.settingsMode ? "active" : ""],
                          attrs: { icon: ["fas", "cog"] },
                          on: {
                            click: function ($event) {
                              _vm.settingsMode = !_vm.settingsMode
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.settingsMode && this.$root.admin
              ? _c("settingsComponent", {
                  attrs: {
                    contentid: _vm.contentid,
                    saving: _vm.saving,
                    settings: this.$root.settings,
                  },
                  on: { newSettings: _vm.newSettings },
                })
              : _vm._e(),
            _c(
              "transition-group",
              { attrs: { name: "bounce" } },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "article",
                  { key: index + 1, staticClass: "newsItem" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            _vm.basedir +
                            item.urlPrefix +
                            item.url.split("?")[0],
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: item.metaTitel,
                            src:
                              _vm.basedir +
                              item.imageUrl +
                              "?w=286&quality=100",
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "contentSnippet" }, [
                      _c("h5", [_vm._v(_vm._s(item.metaTitel))]),
                      _c("p", { staticClass: "publicationDate" }, [
                        _vm._v(
                          _vm._s(
                            new Date(item.publicationDate)
                              .toLocaleDateString(_vm.locale, {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                              })
                              .replace(/\./g, "-")
                          )
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            item.description.length > 100
                              ? item.description.slice(0, 100) + "..."
                              : item.description
                          )
                        ),
                      ]),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.basedir +
                              item.urlPrefix +
                              item.url.split("?")[0],
                          },
                        },
                        [
                          _c("webmessage", {
                            attrs: {
                              searchKey: "wsm_ReadMore",
                              text: _vm.$root.translations.wsm_ReadMore,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("script", { attrs: { type: "application/ld+json" } }, [
                      _vm._v(
                        ' { "@context": "http://schema.org", "@type": "NewsArticle", "mainEntityOfPage": { "@type": "WebPage", "@id": "' +
                          _vm._s(_vm.location) +
                          '" }, "headline": ' +
                          _vm._s(JSON.stringify(item.headers)) +
                          ', "image": [ "' +
                          _vm._s(
                            item.imageUrl.indexOf("http") < 0
                              ? _vm.location + _vm.urlPrefix + item.imageUrl
                              : item.imageUrl
                          ) +
                          '" ], "datePublished": "' +
                          _vm._s(
                            new Date(item.publicationDate)
                              .toISOString()
                              .slice(0, 10)
                          ) +
                          '", "dateModified": "' +
                          _vm._s(
                            new Date(item.publicationDate)
                              .toISOString()
                              .slice(0, 10)
                          ) +
                          '", "author": { "@type": "Organization", "name": "Pharma Nord" }, "publisher": { "@type": "Organization", "name": "Pharma Nord", "logo": { "@type": "ImageObject", "url": "' +
                          _vm._s(_vm.location + _vm.urlPrefix) +
                          '/static/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png" } }, "description": ' +
                          _vm._s(JSON.stringify(item.description)) +
                          " } "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
        _vm.showMore
          ? _c(
              "button",
              {
                staticClass: "loadMoreNews",
                on: {
                  click: function ($event) {
                    _vm.getMoreArticles(
                      parseInt(_vm.items.length) +
                        parseInt(_vm.$root.settings.default)
                    )
                  },
                },
              },
              [
                _c("i", {
                  class: [
                    _vm.loading
                      ? "fad fa-spinner fa-spin"
                      : "fad fa-angle-double-down",
                  ],
                }),
                _vm._v(" "),
                _c("webmessage", {
                  attrs: {
                    searchKey: "wsm_ShowMore",
                    text: _vm.$root.translations.wsm_ShowMore,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }